/* eslint-disable no-nested-ternary */
import React from 'react'
import styled from '@emotion/styled'
import { Typography, Button, Alert, Modal, Card, Space, Input } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import { LottieLoader } from '@src/components/common/LottieLoader'
import { usePaymentInfoPage } from './hooks'
import cardAnimation from './images/card.json'

const { Title, Text } = Typography

export const PaymentInfoPage = () => {
	const {
		card,
		onClickCardRegistration,
		onClickCardDeletion,
		isOpenRegisteringModal,
		errorMessage,
		onCloseErrorMessage,
		promotionCode,
		isInvalidPromotionCode,
		// canSavePromotionCode,
		onChangePromotionCode,
		onClickSkipPromotionCode,
		onClickSavePromotionCode,
		isSavingPromotionCodeRecord,
		isPromotionCodeModalOpened,
		onClosePromotionCodeModal,
		recentPromotionCode,
	} = usePaymentInfoPage()

	return (
		<Container>
			<Title level={5}>등록 카드</Title>
			{card ? (
				<>
					<Card>
						<PaymentCardContent>
							<Space size="large">
								<Text>{`${card.issuer_name}카드, ${card.card_number}`}</Text> {/** TODO */}
								{card.is_default ? <Text>기본 결제 카드</Text> : null}
							</Space>
							<Button type="primary" danger size="small" onClick={onClickCardDeletion}>
								삭제
							</Button>
						</PaymentCardContent>
					</Card>
					<CardFooter>
						<Text style={{ color: '#4e4e4e' }}>
							{recentPromotionCode
								? `등록된 쿠폰 : 스탠다드 한 달 무료 쿠폰(${
										new Date(recentPromotionCode.create_date).getMonth() + 1
								  }/${new Date(recentPromotionCode.create_date).getDate()} 등록)`
								: ''}
						</Text>
						<Text style={{ color: '#4e4e4e' }}>구독 해지는 채널톡으로 1:1 문의해 주세요</Text>
					</CardFooter>
				</>
			) : card === null ? (
				<Button
					icon={<PlusOutlined />}
					style={{ width: '100%', padding: '12px 16px', height: 'unset' }}
					onClick={onClickCardRegistration}
				>
					카드 등록하기
				</Button>
			) : null}
			{card !== undefined && errorMessage ? (
				<Alert
					style={{ marginTop: '6px' }}
					message={errorMessage}
					type="error"
					closable
					onClose={onCloseErrorMessage}
				/>
			) : null}

			<Modal open={isOpenRegisteringModal} closable={false} footer={null} width={650}>
				<RegisteringModalBody>
					<RegisteringModalContent>
						<CardAnimationWrapper>
							<LottieLoader lottieOptions={lottieOptions} />
						</CardAnimationWrapper>
						<Title level={4} style={{ marginTop: '20px' }}>
							카드 등록중이에요
						</Title>
					</RegisteringModalContent>
				</RegisteringModalBody>
			</Modal>

			<Modal
				open={isPromotionCodeModalOpened}
				onCancel={onClosePromotionCodeModal}
				title="프로모션 코드가 있으신가요?"
				closable={false}
				centered
				footer={
					<Space>
						<Button onClick={onClickSkipPromotionCode} disabled={isSavingPromotionCodeRecord}>
							건너뛰기
						</Button>
						<Button
							type="primary"
							onClick={onClickSavePromotionCode}
							loading={isSavingPromotionCodeRecord}
							// disabled={!canSavePromotionCode}
						>
							등록하기
						</Button>
					</Space>
				}
			>
				<Space direction="vertical" size="small" style={{ margin: '20px 0', width: '100%' }}>
					<Text>프로모션 코드 등록</Text>
					<div>
						<Input
							value={promotionCode}
							onChange={(e) => onChangePromotionCode(e.target.value)}
							status={isInvalidPromotionCode ? 'error' : undefined}
							placeholder=" 코드 입력(대소문자 구분)"
						/>
						{isInvalidPromotionCode ? <Text type="danger">유효하지 않은 코드입니다</Text> : null}
					</div>
				</Space>
			</Modal>
		</Container>
	)
}

const lottieOptions = {
	animationData: cardAnimation,
}

const Container = styled.div`
	& .ant-card .ant-card-body {
		padding: 12px 16px;
	}
`

const PaymentCardContent = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`

const RegisteringModalBody = styled.div`
	height: 610px;
	display: flex;
	justify-content: center;
	align-items: center;
`

const RegisteringModalContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const CardAnimationWrapper = styled.div`
	width: 100px;
`

const CardFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 6px;
`
